<template lang="pug">
  v-container.px-10(fluid)
    v-progress-linear(
      :active="loading",
      indeterminate,
      color="white",
      absolute,
      top
    )
    v-row.text-center(v-if="!entity")
      v-col.py-0
        h2.primary--text {{$t('Common.noEntitySelected')}}
        small.white--text {{$t('Common.selectEntityHelp')}}
    v-row(v-else)
      v-col.py-0
        v-card.px-10.py-5.my-5
          v-col.py-0.text-right
            v-btn(color="primary", @click="refresh") {{$t('Common.refresh')}}
              v-icon  mdi-refresh
          v-overlay(absolute, v-if="loading")
          g-data-table(
            dense,
            :headers="headers",
            :items="pagination.data",
            :options.sync="options",
            :server-items-length="pagination.total",
            v-bind="{ loading }",
          )
            template(v-slot:no-data)
              h2 {{ $t("Common.entityNoItems", { entity : $pascalToHuman(entityName)}) }}
              small {{ $t('Common.entityNoItemsHelp') }}
            template(v-slot:top)
              app-entity-search(
                :criteria="$getInitialCriterias($route.params.criteria, pagination.where)"
                @pagination="pagination = $event",
                :entity="entity",
                :loads="loads"
              )
            template(v-slot:item.changes="{ item }")
              v-layout.my-1(v-if="item.changes != null", v-for="change in item.changes")
                v-card.col-md-12(v-if="change != null && change.fieldPath != null")
                  v-card-text(style="padding: 0px")
                    div
                      strong  {{ $t('AutomationLog.fieldPath') }}:
                      label {{ change.fieldPath }}
                    div
                      strong {{ $t('AutomationLog.oldValue') }}:
                      label {{ typeof change.oldValue == "string" ? `"${change.oldValue}"` : change.oldValue }}
                    div
                      strong {{ $t('AutomationLog.newValue') }}:
                      label {{ typeof change.newValue == "string" ? `"${change.newValue}"` : change.newValue }}

    v-row
      v-snackbar(v-model="snackbar")
        | {{ message }}
        v-btn(color="pink", text, @click="snackbar = false")
</template>

<style type="text/css">
.v-data-table td {
  white-space: nowrap;
}
.top-right {
  position: absolute;
  top: 1rem;
  right: .5rem;
}
</style>

<script>
import axios from 'axios'
import keys from 'lodash/keys'
import { AppEntityDelete } from '@@/components'
import AppEntityAutocomplete from '@@/components/EntityAutocomplete.vue'
import EntiyLoadsMixin from "@/mixins/entity-loads.mixin";
import IndexFilterMixin from '@/mixins/index-filter.mixin';

export default {
  components: {
    AppEntityDelete,
    AppEntityAutocomplete
  },
  name: 'automationlog-index',
  mixins: [
    EntiyLoadsMixin,
    IndexFilterMixin,
  ],
  data: () => ({
    message: '',
    snackbar: false,
    loading: false,
    timer: null,
    wait: 500,
    pagination: {},
    options: {},
  }),

  watch: {
    $route: {
      immediate: true,
      handler () {
        this.clear();
        this.load(this.options);
      }
    },
    options: {
      handler (options) {
        this.load(options)
      }
    }
  },

  computed: {
    entityName () {
      return 'AutomationLog'
    },
    entity () {
      return this.$searchEntity(this.entityName, 'name')
    },
    headers() {
      return ([
        { text: this.$t("AutomationLog.itemExternalId"), value: "itemExternalId" },
        { text: this.$t("AutomationLog.automationType"), value: "automationType" },
        { text: this.$t("AutomationLog.description"), value: "description" },
        { text: this.$t("AutomationLog.changes"), value: "changes", width: "320px" },
        { text: this.$t("AutomationLog.createdAt"), value: "recordedAt" },
      ]);
    },
  },
  methods: {
    getPagination(options = null, where = null) {
      options = options || this.options
      if (!keys(options).length) return
      return {
        params: {
          page: options.page,
          pageSize: options.itemsPerPage,
          orderBy: options.sortBy[0],
          desc: options.sortDesc[0],
          where: where,
        }
      }
    },

    /* TODO: docs */
    async load (options = null) {
      clearTimeout(this.timer)
      this.timer = setTimeout(async () => {
        const pagination = this.getPagination(options, this.pagination.where)
        if (this.entity) {
          this.loading = true
          try {
            const envEndpoint = _.get(ENV.ENTITIES, this.entityName  + '.index.endpoint');
            const envParams = _.get(ENV.ENTITIES, this.entityName  + '.index.params', { withoutGlobalBusinessScope: true });
            pagination.params = _.merge(pagination.params, envParams);
            this.pagination = (await axios.get(this.$fetchLoad(envEndpoint || this.entityName, !envEndpoint, ...this.loads), pagination)).data
          } catch (err) {}
          this.loading = false
        }
      }, this.wait)
    },

    clear () {
      this.options = {
        ...this.options,
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      };
    },

    refresh () {
      this.clear();
      this.load();
    }
  }
}
</script>
